import { Extension } from "@tiptap/core";
import { TextSelection } from "prosemirror-state";

const SelectAllDocument = Extension.create({
  name: "selectAllDocument",

  addKeyboardShortcuts() {
    return {
      "Mod-a": ({ editor }) => {
        const { doc } = editor.state;
        const { tr } = editor.state;
        tr.setSelection(TextSelection.create(doc, 0, doc.content.size));
        editor.view.dispatch(tr);
        return true;
      },
    };
  },
});

export default SelectAllDocument;
